export const warpRouteConfigs = {
    "amphrETH/arbitrum-ethereum-zircuit": {
        "tokens": [
            {
                "addressOrDenom": "0x6D251aADfc6Ff69031e01eA39bE3cb5BABf8438f",
                "chainName": "arbitrum",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xdc89990a6fdC1C922b841f1d977835628A24Ed57"
                    },
                    {
                        "token": "ethereum|zircuit|0x7D5a79539d7B1c9aE5e54d18EEE188840f1Fe4CC"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/AMPHRETH/logo.svg",
                "name": "Amphor Restaked ETH",
                "standard": "EvmHypSynthetic",
                "symbol": "amphrETH"
            },
            {
                "addressOrDenom": "0xdc89990a6fdC1C922b841f1d977835628A24Ed57",
                "chainName": "ethereum",
                "coinGeckoId": "ethereum",
                "collateralAddressOrDenom": "0x5fD13359Ba15A84B76f7F87568309040176167cd",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x6D251aADfc6Ff69031e01eA39bE3cb5BABf8438f"
                    },
                    {
                        "token": "ethereum|zircuit|0x7D5a79539d7B1c9aE5e54d18EEE188840f1Fe4CC"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/AMPHRETH/logo.svg",
                "name": "Amphor Restaked ETH",
                "standard": "EvmHypCollateral",
                "symbol": "amphrETH"
            },
            {
                "addressOrDenom": "0x7D5a79539d7B1c9aE5e54d18EEE188840f1Fe4CC",
                "chainName": "zircuit",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x6D251aADfc6Ff69031e01eA39bE3cb5BABf8438f"
                    },
                    {
                        "token": "ethereum|ethereum|0xdc89990a6fdC1C922b841f1d977835628A24Ed57"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/AMPHRETH/logo.svg",
                "name": "Amphor Restaked ETH",
                "standard": "EvmHypSynthetic",
                "symbol": "amphrETH"
            }
        ]
    },
    "ATN/holesky-piccadilly": {
        "tokens": [
            {
                "addressOrDenom": "0x123B520fDd5De936bd94A73a2D6225C1276771c9",
                "chainName": "holesky",
                "connections": [
                    {
                        "token": "ethereum|piccadilly|0xB7A40dBEcf4b970BA58AFEC95f484CbCaEB6b234"
                    }
                ],
                "decimals": 18,
                "name": "Auton",
                "standard": "EvmHypSynthetic",
                "symbol": "ATN"
            },
            {
                "addressOrDenom": "0xB7A40dBEcf4b970BA58AFEC95f484CbCaEB6b234",
                "chainName": "piccadilly",
                "connections": [
                    {
                        "token": "ethereum|holesky|0x123B520fDd5De936bd94A73a2D6225C1276771c9"
                    }
                ],
                "decimals": 18,
                "name": "Auton",
                "standard": "EvmHypNative",
                "symbol": "ATN"
            }
        ]
    },
    "BNB/bsc-kalychain": {
        "tokens": [
            {
                "addressOrDenom": "0x8d0e034611B691683377d2fC9958122a30F7DAab",
                "chainName": "bsc",
                "connections": [
                    {
                        "token": "ethereum|kalychain|0x0e2318b62a096AC68ad2D7F37592CBf0cA9c4Ddb"
                    }
                ],
                "decimals": 18,
                "name": "BNB",
                "standard": "EvmHypNative",
                "symbol": "BNB"
            },
            {
                "addressOrDenom": "0x0e2318b62a096AC68ad2D7F37592CBf0cA9c4Ddb",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|bsc|0x8d0e034611B691683377d2fC9958122a30F7DAab"
                    }
                ],
                "decimals": 18,
                "name": "BNB",
                "standard": "EvmHypSynthetic",
                "symbol": "BNB"
            }
        ]
    },
    "DAI/arbitrum-bsc-kalychain-polygon": {
        "tokens": [
            {
                "addressOrDenom": "0x1e59F72de6c00c456f7F42708FE8b6b0782E84C6",
                "chainName": "arbitrum",
                "collateralAddressOrDenom": "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
                "connections": [
                    {
                        "token": "ethereum|bsc|0x7379A18963039eA1284050b585f422e8156c9eC0"
                    },
                    {
                        "token": "ethereum|kalychain|0x6E92CAC380F7A7B86f4163fad0df2F277B16Edc6"
                    },
                    {
                        "token": "ethereum|polygon|0x1E71a8d870F0C491d4fCC965A59493b8B7564949"
                    }
                ],
                "decimals": 18,
                "name": "Dai Stablecoin",
                "standard": "EvmHypCollateral",
                "symbol": "DAI"
            },
            {
                "addressOrDenom": "0x7379A18963039eA1284050b585f422e8156c9eC0",
                "chainName": "bsc",
                "collateralAddressOrDenom": "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x1e59F72de6c00c456f7F42708FE8b6b0782E84C6"
                    },
                    {
                        "token": "ethereum|kalychain|0x6E92CAC380F7A7B86f4163fad0df2F277B16Edc6"
                    },
                    {
                        "token": "ethereum|polygon|0x1E71a8d870F0C491d4fCC965A59493b8B7564949"
                    }
                ],
                "decimals": 18,
                "name": "Dai Stablecoin",
                "standard": "EvmHypCollateral",
                "symbol": "DAI"
            },
            {
                "addressOrDenom": "0x6E92CAC380F7A7B86f4163fad0df2F277B16Edc6",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x1e59F72de6c00c456f7F42708FE8b6b0782E84C6"
                    },
                    {
                        "token": "ethereum|bsc|0x7379A18963039eA1284050b585f422e8156c9eC0"
                    },
                    {
                        "token": "ethereum|polygon|0x1E71a8d870F0C491d4fCC965A59493b8B7564949"
                    }
                ],
                "decimals": 18,
                "name": "Dai Stablecoin",
                "standard": "EvmHypSynthetic",
                "symbol": "DAI"
            },
            {
                "addressOrDenom": "0x1E71a8d870F0C491d4fCC965A59493b8B7564949",
                "chainName": "polygon",
                "collateralAddressOrDenom": "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x1e59F72de6c00c456f7F42708FE8b6b0782E84C6"
                    },
                    {
                        "token": "ethereum|bsc|0x7379A18963039eA1284050b585f422e8156c9eC0"
                    },
                    {
                        "token": "ethereum|kalychain|0x6E92CAC380F7A7B86f4163fad0df2F277B16Edc6"
                    }
                ],
                "decimals": 18,
                "name": "Dai Stablecoin",
                "standard": "EvmHypCollateral",
                "symbol": "DAI"
            }
        ]
    },
    "DOG/base-optimism": {
        "tokens": [
            {
                "addressOrDenom": "0x91f016B43A73DFF60f5D910c530338f69Fa3FD0b",
                "chainName": "base",
                "collateralAddressOrDenom": "0xafb89a09d82fbde58f18ac6437b3fc81724e4df6",
                "connections": [
                    {
                        "token": "ethereum|optimism|0x8da914daf9fc05D0e31435f7bd9633ffFC41f20B"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/DOG/logo.jpg",
                "name": "The Doge NFT",
                "standard": "EvmHypCollateral",
                "symbol": "DOG"
            },
            {
                "addressOrDenom": "0x8da914daf9fc05D0e31435f7bd9633ffFC41f20B",
                "chainName": "optimism",
                "connections": [
                    {
                        "token": "ethereum|base|0x91f016B43A73DFF60f5D910c530338f69Fa3FD0b"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/DOG/logo.jpg",
                "name": "The Doge NFT",
                "standard": "EvmHypSynthetic",
                "symbol": "DOG"
            }
        ]
    },
    "EAURA/euphoriatestnet-storyodysseytestnet": {
        "tokens": [
            {
                "addressOrDenom": "0x17Ba7b7D6110DE065C10321D64cdfbAFAb6De255",
                "chainName": "euphoriatestnet",
                "connections": [
                    {
                        "token": "ethereum|storyodysseytestnet|0xE8855CE4d715fA8622B9d1c45214661f99D05D75"
                    }
                ],
                "decimals": 18,
                "name": "Euphoria Aura",
                "standard": "EvmHypNative",
                "symbol": "EAURA"
            },
            {
                "addressOrDenom": "0xE8855CE4d715fA8622B9d1c45214661f99D05D75",
                "chainName": "storyodysseytestnet",
                "connections": [
                    {
                        "token": "ethereum|euphoriatestnet|0x17Ba7b7D6110DE065C10321D64cdfbAFAb6De255"
                    }
                ],
                "decimals": 18,
                "name": "Euphoria Aura",
                "standard": "EvmHypSynthetic",
                "symbol": "EAURA"
            }
        ]
    },
    "EAURA/euphoriatestnet-storytestnet": {
        "tokens": [
            {
                "addressOrDenom": "0x4BD4B868D23d1dB8181c1913C331d7AB1CeA8B24",
                "chainName": "euphoriatestnet",
                "connections": [
                    {
                        "token": "ethereum|storytestnet|0xc119436eA9a29f3802c77EBc3F0601384a6F8eCE"
                    }
                ],
                "decimals": 18,
                "name": "Euphoria Aura",
                "standard": "EvmHypNative",
                "symbol": "EAURA"
            },
            {
                "addressOrDenom": "0xc119436eA9a29f3802c77EBc3F0601384a6F8eCE",
                "chainName": "storytestnet",
                "connections": [
                    {
                        "token": "ethereum|euphoriatestnet|0x4BD4B868D23d1dB8181c1913C331d7AB1CeA8B24"
                    }
                ],
                "decimals": 18,
                "name": "Euphoria Aura",
                "standard": "EvmHypSynthetic",
                "symbol": "EAURA"
            }
        ]
    },
    "ECLIP/arbitrum-neutron": {
        "tokens": [
            {
                "addressOrDenom": "neutron1dvzvf870mx9uf65uqhx40yzx9gu4xlqqq2pnx362a0ndmustww3smumrf5",
                "chainName": "neutron",
                "collateralAddressOrDenom": "factory/neutron10sr06r3qkhn7xzpw3339wuj77hu06mzna6uht0/eclip",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x93ca0d85837FF83158Cd14D65B169CdB223b1921"
                    }
                ],
                "decimals": 6,
                "igpTokenAddressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                "logoURI": "/deployments/warp_routes/ECLIP/logo.svg",
                "name": "Eclipse Fi",
                "standard": "CwHypCollateral",
                "symbol": "ECLIP"
            },
            {
                "addressOrDenom": "0x93ca0d85837FF83158Cd14D65B169CdB223b1921",
                "chainName": "arbitrum",
                "connections": [
                    {
                        "token": "cosmos|neutron|neutron1dvzvf870mx9uf65uqhx40yzx9gu4xlqqq2pnx362a0ndmustww3smumrf5"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/ECLIP/logo.svg",
                "name": "Eclipse Fi",
                "standard": "EvmHypSynthetic",
                "symbol": "ECLIP"
            },
            {
                "addressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                "chainName": "neutron",
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.n",
                "standard": "CosmosIbc",
                "symbol": "TIA.n"
            }
        ]
    },
    "ETH/alfajores-sepolia": {
        "tokens": [
            {
                "addressOrDenom": "0x78fe869f19f917fde4192c51c446Fbd3721788ee",
                "chainName": "alfajores",
                "connections": [
                    {
                        "token": "ethereum|sepolia|0xeDF994D49F865D3a4bd6F74AeFbe1DcCAE7204F2"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/ETH/logo.svg",
                "name": "Ether",
                "standard": "EvmHypSynthetic",
                "symbol": "ETH"
            },
            {
                "addressOrDenom": "0xeDF994D49F865D3a4bd6F74AeFbe1DcCAE7204F2",
                "chainName": "sepolia",
                "connections": [
                    {
                        "token": "ethereum|alfajores|0x78fe869f19f917fde4192c51c446Fbd3721788ee"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/ETH/logo.svg",
                "name": "Ether",
                "standard": "EvmHypNative",
                "symbol": "ETH"
            }
        ]
    },
    "ETH/arbitrum-bsc-kalychain-polygon": {
        "tokens": [
            {
                "addressOrDenom": "0x14CFC15Da10d5cfC6A494E183c795067573C7F51",
                "chainName": "arbitrum",
                "connections": [
                    {
                        "token": "ethereum|bsc|0xF29AD0640731c50d0c7C999D1f8d5Ffb9E2A3da3"
                    },
                    {
                        "token": "ethereum|kalychain|0xfdbB253753dDE60b11211B169dC872AaE672879b"
                    },
                    {
                        "token": "ethereum|polygon|0xb974461a9ef2Ff3F408798f551929647ceaB13b4"
                    }
                ],
                "decimals": 18,
                "name": "Ether",
                "standard": "EvmHypNative",
                "symbol": "ETH"
            },
            {
                "addressOrDenom": "0xF29AD0640731c50d0c7C999D1f8d5Ffb9E2A3da3",
                "chainName": "bsc",
                "collateralAddressOrDenom": "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x14CFC15Da10d5cfC6A494E183c795067573C7F51"
                    },
                    {
                        "token": "ethereum|kalychain|0xfdbB253753dDE60b11211B169dC872AaE672879b"
                    },
                    {
                        "token": "ethereum|polygon|0xb974461a9ef2Ff3F408798f551929647ceaB13b4"
                    }
                ],
                "decimals": 18,
                "name": "Ether",
                "standard": "EvmHypCollateral",
                "symbol": "ETH"
            },
            {
                "addressOrDenom": "0xfdbB253753dDE60b11211B169dC872AaE672879b",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x14CFC15Da10d5cfC6A494E183c795067573C7F51"
                    },
                    {
                        "token": "ethereum|bsc|0xF29AD0640731c50d0c7C999D1f8d5Ffb9E2A3da3"
                    },
                    {
                        "token": "ethereum|polygon|0xb974461a9ef2Ff3F408798f551929647ceaB13b4"
                    }
                ],
                "decimals": 18,
                "name": "Ether",
                "standard": "EvmHypSynthetic",
                "symbol": "ETH"
            },
            {
                "addressOrDenom": "0xb974461a9ef2Ff3F408798f551929647ceaB13b4",
                "chainName": "polygon",
                "collateralAddressOrDenom": "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x14CFC15Da10d5cfC6A494E183c795067573C7F51"
                    },
                    {
                        "token": "ethereum|bsc|0xF29AD0640731c50d0c7C999D1f8d5Ffb9E2A3da3"
                    },
                    {
                        "token": "ethereum|kalychain|0xfdbB253753dDE60b11211B169dC872AaE672879b"
                    }
                ],
                "decimals": 18,
                "name": "Ether",
                "standard": "EvmHypCollateral",
                "symbol": "ETH"
            }
        ]
    },
    "ETH/ethereum-viction": {
        "tokens": [
            {
                "addressOrDenom": "0x15b5D6B614242B118AA404528A7f3E2Ad241e4A4",
                "chainName": "ethereum",
                "coinGeckoId": "ethereum",
                "connections": [
                    {
                        "token": "ethereum|viction|0x182e8d7c5f1b06201b102123fc7df0eaeb445a7b"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/ETH/logo.svg",
                "name": "Ethereum",
                "standard": "EvmHypNative",
                "symbol": "ETH"
            },
            {
                "addressOrDenom": "0x182e8d7c5f1b06201b102123fc7df0eaeb445a7b",
                "chainName": "viction",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x15b5D6B614242B118AA404528A7f3E2Ad241e4A4"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/ETH/logo.svg",
                "name": "Ethereum",
                "standard": "EvmHypSynthetic",
                "symbol": "ETH"
            }
        ]
    },
    "ETH/holesky-piccadilly": {
        "tokens": [
            {
                "addressOrDenom": "0x7f8C02dA6A2f56bD5ae52524717477B7d79F8D5C",
                "chainName": "holesky",
                "connections": [
                    {
                        "token": "ethereum|piccadilly|0x49195E6251aFa947319F29351be4bDfA617C6720"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/ETH/logo.svg",
                "name": "Ether",
                "standard": "EvmHypNative",
                "symbol": "ETH"
            },
            {
                "addressOrDenom": "0x49195E6251aFa947319F29351be4bDfA617C6720",
                "chainName": "piccadilly",
                "connections": [
                    {
                        "token": "ethereum|holesky|0x7f8C02dA6A2f56bD5ae52524717477B7d79F8D5C"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/ETH/logo.svg",
                "name": "Ether",
                "standard": "EvmHypSynthetic",
                "symbol": "ETH"
            }
        ]
    },
    "ezETH/arbitrum-base-blast-bsc-ethereum-fraxtal-linea-mode-optimism-sei-taiko-zircuit": {
        "tokens": [
            {
                "addressOrDenom": "0xB26bBfC6d1F469C821Ea25099017862e7368F4E8",
                "chainName": "arbitrum",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2",
                "chainName": "optimism",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0x2552516453368e42705D791F674b312b8b87CD9e",
                "chainName": "base",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0x486b39378f99f073A3043C6Aabe8666876A8F3C5",
                "chainName": "blast",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0xE00C6185a5c19219F1FFeD213b4406a254968c26",
                "chainName": "bsc",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0xC59336D8edDa9722B4f1Ec104007191Ec16f7087",
                "chainName": "mode",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0xC59336D8edDa9722B4f1Ec104007191Ec16f7087",
                "chainName": "linea",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0xC59336D8edDa9722B4f1Ec104007191Ec16f7087",
                "chainName": "ethereum",
                "coinGeckoId": "renzo-restaked-eth",
                "collateralAddressOrDenom": "0xC8140dA31E6bCa19b287cC35531c2212763C2059",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20Lockbox",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5",
                "chainName": "fraxtal",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0x2552516453368e42705D791F674b312b8b87CD9e",
                "chainName": "zircuit",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78",
                "chainName": "taiko",
                "collateralAddressOrDenom": "0x2416092f143378750bb29b79eD961ab195CcEea5",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|sei|0xE5163F148C82a0818545d5D34e30BC1EDA870cB9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/logo.svg",
                "name": "Renzo Restaked ETH",
                "standard": "EvmHypXERC20",
                "symbol": "ezETH"
            },
            {
                "addressOrDenom": "0xE5163F148C82a0818545d5D34e30BC1EDA870cB9",
                "chainName": "sei",
                "collateralAddressOrDenom": "0x6DCfbF4729890043DFd34A93A2694E5303BA2703",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xB26bBfC6d1F469C821Ea25099017862e7368F4E8"
                    },
                    {
                        "token": "ethereum|optimism|0xacEB607CdF59EB8022Cc0699eEF3eCF246d149e2"
                    },
                    {
                        "token": "ethereum|base|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|blast|0x486b39378f99f073A3043C6Aabe8666876A8F3C5"
                    },
                    {
                        "token": "ethereum|bsc|0xE00C6185a5c19219F1FFeD213b4406a254968c26"
                    },
                    {
                        "token": "ethereum|mode|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|linea|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|ethereum|0xC59336D8edDa9722B4f1Ec104007191Ec16f7087"
                    },
                    {
                        "token": "ethereum|fraxtal|0x3aE8635A4D581d40a6Edfb3f2ED480f9532994F5"
                    },
                    {
                        "token": "ethereum|zircuit|0x2552516453368e42705D791F674b312b8b87CD9e"
                    },
                    {
                        "token": "ethereum|taiko|0x5eAFB1D4b5BDFaFE81715EeBcC7713e418C80E78"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/EZETH/RedETH-logo.svg",
                "name": "Restaked ETH on Sei",
                "standard": "EvmHypXERC20",
                "symbol": "redETH"
            }
        ]
    },
    "fastUSD/ethereum-sei": {
        "tokens": [
            {
                "addressOrDenom": "0xeA895A7Ff45d8d3857A04c1E38A362f3bd9a076f",
                "chainName": "sei",
                "collateralAddressOrDenom": "0x37a4dD9CED2b19Cfe8FAC251cd727b5787E45269",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x9AD81058c6C3Bf552C9014CB30E824717A0ee21b"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/FASTUSD/logo.svg",
                "name": "fastUSD",
                "standard": "EvmHypXERC20",
                "symbol": "fastUSD"
            },
            {
                "addressOrDenom": "0x9AD81058c6C3Bf552C9014CB30E824717A0ee21b",
                "chainName": "ethereum",
                "coinGeckoId": "elixir-deusd",
                "collateralAddressOrDenom": "0x15700B564Ca08D9439C58cA5053166E8317aa138",
                "connections": [
                    {
                        "token": "ethereum|sei|0xeA895A7Ff45d8d3857A04c1E38A362f3bd9a076f"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/FASTUSD/logo.svg",
                "name": "fastUSD",
                "standard": "EvmHypCollateral",
                "symbol": "fastUSD"
            }
        ]
    },
    "INJ/inevm-injective": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "inj",
                    "amount": "30000000000000000",
                    "destination": "inevm",
                    "origin": "injective"
                }
            ],
            "localFeeConstants": [
                {
                    "addressOrDenom": "inj",
                    "amount": "1000000000000000",
                    "destination": "inevm",
                    "origin": "injective"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "inj1mv9tjvkaw7x8w8y9vds8pkfq46g2vcfkjehc6k",
                "chainName": "injective",
                "coinGeckoId": "injective-protocol",
                "connections": [
                    {
                        "token": "ethereum|inevm|0x26f32245fCF5Ad53159E875d5Cae62aEcf19c2d4"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/INJ/logo.svg",
                "name": "Injective Coin",
                "standard": "CwHypNative",
                "symbol": "INJ"
            },
            {
                "addressOrDenom": "0x26f32245fCF5Ad53159E875d5Cae62aEcf19c2d4",
                "chainName": "inevm",
                "connections": [
                    {
                        "token": "cosmos|injective|inj1mv9tjvkaw7x8w8y9vds8pkfq46g2vcfkjehc6k"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/INJ/logo.svg",
                "name": "Injective Coin",
                "standard": "EvmHypNative",
                "symbol": "INJ"
            }
        ]
    },
    "KLC/arbitrum-bsc-kalychain-polygon": {
        "tokens": [
            {
                "addressOrDenom": "0x7542c62565f48520A34Cf79884656efDEdD38176",
                "chainName": "arbitrum",
                "connections": [
                    {
                        "token": "ethereum|bsc|0x02CF1778c07584D92b610E0C03fA285DfD00c354"
                    },
                    {
                        "token": "ethereum|kalychain|0x8A1ABbB167b149F2493C8141091028fD812Da6E4"
                    },
                    {
                        "token": "ethereum|polygon|0x285C14145EB75A1918B48f93E126139ea1a0f294"
                    }
                ],
                "decimals": 18,
                "name": "KalyCoin",
                "standard": "EvmHypSynthetic",
                "symbol": "KLC"
            },
            {
                "addressOrDenom": "0x02CF1778c07584D92b610E0C03fA285DfD00c354",
                "chainName": "bsc",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x7542c62565f48520A34Cf79884656efDEdD38176"
                    },
                    {
                        "token": "ethereum|kalychain|0x8A1ABbB167b149F2493C8141091028fD812Da6E4"
                    },
                    {
                        "token": "ethereum|polygon|0x285C14145EB75A1918B48f93E126139ea1a0f294"
                    }
                ],
                "decimals": 18,
                "name": "KalyCoin",
                "standard": "EvmHypSynthetic",
                "symbol": "KLC"
            },
            {
                "addressOrDenom": "0x8A1ABbB167b149F2493C8141091028fD812Da6E4",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x7542c62565f48520A34Cf79884656efDEdD38176"
                    },
                    {
                        "token": "ethereum|bsc|0x02CF1778c07584D92b610E0C03fA285DfD00c354"
                    },
                    {
                        "token": "ethereum|polygon|0x285C14145EB75A1918B48f93E126139ea1a0f294"
                    }
                ],
                "decimals": 18,
                "name": "KalyCoin",
                "standard": "EvmHypNative",
                "symbol": "KLC"
            },
            {
                "addressOrDenom": "0x285C14145EB75A1918B48f93E126139ea1a0f294",
                "chainName": "polygon",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x7542c62565f48520A34Cf79884656efDEdD38176"
                    },
                    {
                        "token": "ethereum|bsc|0x02CF1778c07584D92b610E0C03fA285DfD00c354"
                    },
                    {
                        "token": "ethereum|kalychain|0x8A1ABbB167b149F2493C8141091028fD812Da6E4"
                    }
                ],
                "decimals": 18,
                "name": "KalyCoin",
                "standard": "EvmHypSynthetic",
                "symbol": "KLC"
            }
        ]
    },
    "LESS/arthera-celo": {
        "tokens": [
            {
                "addressOrDenom": "0xa6D019ea6D132FF091d5bef0B077EC1e045c9461",
                "chainName": "arthera",
                "collateralAddressOrDenom": "0xdc93F137EdfB14133686e90de9C845A7c7Fca3De",
                "connections": [
                    {
                        "token": "ethereum|celo|0x2201B4cC55c82EE23554C9CDA5CFF62BBa01c69D"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/LESS/logo.svg",
                "name": "Lessgas",
                "standard": "EvmHypCollateral",
                "symbol": "LESS"
            },
            {
                "addressOrDenom": "0x2201B4cC55c82EE23554C9CDA5CFF62BBa01c69D",
                "chainName": "celo",
                "connections": [
                    {
                        "token": "ethereum|arthera|0xa6D019ea6D132FF091d5bef0B077EC1e045c9461"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/LESS/logo.svg",
                "name": "Lessgas",
                "standard": "EvmHypSynthetic",
                "symbol": "LESS"
            }
        ]
    },
    "LESS/artheratestnet-holesky": {
        "tokens": [
            {
                "addressOrDenom": "0x48867511B5c9c6A0E28b36553cd0DC9A0A95A6D2",
                "chainName": "artheratestnet",
                "collateralAddressOrDenom": "0xcae706200441f8D3f8E880B7C977c57f0c4747d5",
                "connections": [
                    {
                        "token": "ethereum|holesky|0x2201B4cC55c82EE23554C9CDA5CFF62BBa01c69D"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/LESS/logo.svg",
                "name": "Lessgas",
                "standard": "EvmHypCollateral",
                "symbol": "LESS"
            },
            {
                "addressOrDenom": "0x2201B4cC55c82EE23554C9CDA5CFF62BBa01c69D",
                "chainName": "holesky",
                "connections": [
                    {
                        "token": "ethereum|artheratestnet|0x48867511B5c9c6A0E28b36553cd0DC9A0A95A6D2"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/LESS/logo.svg",
                "name": "Lessgas",
                "standard": "EvmHypSynthetic",
                "symbol": "LESS"
            }
        ]
    },
    "LUMIA/bsc-ethereum-lumia": {
        "tokens": [
            {
                "addressOrDenom": "0xdD313D475f8A9d81CBE2eA953a357f52e10BA357",
                "chainName": "ethereum",
                "coinGeckoId": "lumia",
                "collateralAddressOrDenom": "0xd9343a049d5dbd89cd19dc6bca8c48fb3a0a42a7",
                "connections": [
                    {
                        "token": "ethereum|bsc|0x7F39BcdCa8E0E581c1d43aaa1cB862AA1c8C2047"
                    },
                    {
                        "token": "ethereum|lumia|0x6a77331cE28E47c3Cb9Fea48AB6cD1e9594ce0A9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/LUMIA/logo.svg",
                "name": "Lumia Token",
                "standard": "EvmHypCollateral",
                "symbol": "LUMIA"
            },
            {
                "addressOrDenom": "0x7F39BcdCa8E0E581c1d43aaa1cB862AA1c8C2047",
                "chainName": "bsc",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xdD313D475f8A9d81CBE2eA953a357f52e10BA357"
                    },
                    {
                        "token": "ethereum|lumia|0x6a77331cE28E47c3Cb9Fea48AB6cD1e9594ce0A9"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/LUMIA/logo.svg",
                "name": "Lumia Token",
                "standard": "EvmHypSynthetic",
                "symbol": "LUMIA"
            },
            {
                "addressOrDenom": "0x6a77331cE28E47c3Cb9Fea48AB6cD1e9594ce0A9",
                "chainName": "lumia",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xdD313D475f8A9d81CBE2eA953a357f52e10BA357"
                    },
                    {
                        "token": "ethereum|bsc|0x7F39BcdCa8E0E581c1d43aaa1cB862AA1c8C2047"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/LUMIA/logo.svg",
                "name": "Lumia Token",
                "standard": "EvmHypNative",
                "symbol": "LUMIA"
            }
        ]
    },
    "NTN/holesky-piccadilly": {
        "tokens": [
            {
                "addressOrDenom": "0xdF73856d44C1f7b3B14Fd0DaD8B0792fCf1c3f68",
                "chainName": "holesky",
                "connections": [
                    {
                        "token": "ethereum|piccadilly|0xB671973E737c1793eE5AbCaA97769d7a81445704"
                    }
                ],
                "decimals": 18,
                "name": "Newton",
                "standard": "EvmHypSynthetic",
                "symbol": "NTN"
            },
            {
                "addressOrDenom": "0xB671973E737c1793eE5AbCaA97769d7a81445704",
                "chainName": "piccadilly",
                "collateralAddressOrDenom": "0xBd770416a3345F91E4B34576cb804a576fa48EB1",
                "connections": [
                    {
                        "token": "ethereum|holesky|0xdF73856d44C1f7b3B14Fd0DaD8B0792fCf1c3f68"
                    }
                ],
                "decimals": 18,
                "name": "Newton",
                "standard": "EvmHypCollateral",
                "symbol": "NTN"
            }
        ]
    },
    "ORCA/eclipsemainnet-solanamainnet": {
        "tokens": [
            {
                "addressOrDenom": "8CvWJS7SPtauAXinJUURkBDLsGUXWiiTdENkEFUPjQ9j",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "2tGbYEm4nuPFyS6zjDTELzEhvVKizgKewi6xT7AaSKzn",
                "connections": [
                    {
                        "token": "sealevel|solanamainnet|8acihSm2QTGswniKgdgr4JBvJihZ1cakfvbqWCPBLoSp"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/ORCA/logo.svg",
                "name": "Orca",
                "standard": "SealevelHypSynthetic",
                "symbol": "ORCA"
            },
            {
                "addressOrDenom": "8acihSm2QTGswniKgdgr4JBvJihZ1cakfvbqWCPBLoSp",
                "chainName": "solanamainnet",
                "coinGeckoId": "orca",
                "collateralAddressOrDenom": "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|8CvWJS7SPtauAXinJUURkBDLsGUXWiiTdENkEFUPjQ9j"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/ORCA/logo.svg",
                "name": "Orca",
                "standard": "SealevelHypCollateral",
                "symbol": "ORCA"
            }
        ]
    },
    "POL/kalychain-polygon": {
        "tokens": [
            {
                "addressOrDenom": "0x706C9a63d7c8b7Aaf85DDCca52654645f470E8Ac",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|polygon|0x0a6364152EA7a487C697a36Eb2522f48bC62fB4c"
                    }
                ],
                "decimals": 18,
                "name": "Polygon Ecosystem Token",
                "standard": "EvmHypSynthetic",
                "symbol": "POL"
            },
            {
                "addressOrDenom": "0x0a6364152EA7a487C697a36Eb2522f48bC62fB4c",
                "chainName": "polygon",
                "connections": [
                    {
                        "token": "ethereum|kalychain|0x706C9a63d7c8b7Aaf85DDCca52654645f470E8Ac"
                    }
                ],
                "decimals": 18,
                "name": "Polygon Ecosystem Token",
                "standard": "EvmHypNative",
                "symbol": "POL"
            }
        ]
    },
    "pzETH/ethereum-zircuit": {
        "tokens": [
            {
                "addressOrDenom": "0x0220b1EA1b56ECE8e2b62c8965659f0A621e9ebd",
                "chainName": "ethereum",
                "coinGeckoId": "renzo-restaked-lst",
                "collateralAddressOrDenom": "0xbC5511354C4A9a50DE928F56DB01DD327c4e56d5",
                "connections": [
                    {
                        "token": "ethereum|zircuit|0x8303Ce0E207BB44a3D3B2313AC219d0fC73b3764"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/PZETH/logo.svg",
                "name": "Renzo Restaked LST ",
                "standard": "EvmHypXERC20Lockbox",
                "symbol": "pzETH"
            },
            {
                "addressOrDenom": "0x8303Ce0E207BB44a3D3B2313AC219d0fC73b3764",
                "chainName": "zircuit",
                "collateralAddressOrDenom": "0x9cb41CD74D01ae4b4f640EC40f7A60cA1bCF83E7",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x0220b1EA1b56ECE8e2b62c8965659f0A621e9ebd"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/PZETH/logo.svg",
                "name": "Renzo Restaked LST ",
                "standard": "EvmHypXERC20",
                "symbol": "pzETH"
            }
        ]
    },
    "SOL/eclipsemainnet-solanamainnet": {
        "tokens": [
            {
                "addressOrDenom": "FJu4E1BDYKVg7aTWdwATZRUvytJZ8ZZ2gQuvPfMWAz9y",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "BeRUj3h7BqkbdfFU7FBNYbodgf8GCHodzKvF9aVjNNfL",
                "connections": [
                    {
                        "token": "sealevel|solanamainnet|8DtAGQpcMuD5sG3KdxDy49ydqXUggR1LQtebh2TECbAc"
                    }
                ],
                "decimals": 9,
                "logoURI": "/deployments/warp_routes/SOL/logo.svg",
                "name": "Solana",
                "standard": "SealevelHypSynthetic",
                "symbol": "SOL"
            },
            {
                "addressOrDenom": "8DtAGQpcMuD5sG3KdxDy49ydqXUggR1LQtebh2TECbAc",
                "chainName": "solanamainnet",
                "coinGeckoId": "solana",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|FJu4E1BDYKVg7aTWdwATZRUvytJZ8ZZ2gQuvPfMWAz9y"
                    }
                ],
                "decimals": 9,
                "logoURI": "/deployments/warp_routes/SOL/logo.svg",
                "name": "Solana",
                "standard": "SealevelHypNative",
                "symbol": "SOL"
            }
        ]
    },
    "tAURA/euphoriatestnet-holesky": {
        "tokens": [
            {
                "addressOrDenom": "0x120f461C4d95412c4a1BC4e8BE6917C9da404510",
                "chainName": "euphoriatestnet",
                "connections": [
                    {
                        "token": "ethereum|holesky|0x0bA0E052b993E8486AA8dab82c361404F7576573"
                    }
                ],
                "decimals": 18,
                "name": "Aura Testing",
                "standard": "EvmHypSynthetic",
                "symbol": "tAURA"
            },
            {
                "addressOrDenom": "0x0bA0E052b993E8486AA8dab82c361404F7576573",
                "chainName": "holesky",
                "collateralAddressOrDenom": "0x89C17409dc7222E378A433CE75DDd4dF8a1c4874",
                "connections": [
                    {
                        "token": "ethereum|euphoriatestnet|0x120f461C4d95412c4a1BC4e8BE6917C9da404510"
                    }
                ],
                "decimals": 18,
                "name": "Aura Testing",
                "standard": "EvmHypCollateral",
                "symbol": "tAURA"
            }
        ]
    },
    "TIA.n/arbitrum-neutron": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                    "amount": 270000,
                    "destination": "arbitrum",
                    "origin": "neutron"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "neutron1jyyjd3x0jhgswgm6nnctxvzla8ypx50tew3ayxxwkrjfxhvje6kqzvzudq",
                "chainName": "neutron",
                "coinGeckoId": "celestia",
                "collateralAddressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xD56734d7f9979dD94FAE3d67C7e928234e71cD4C"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.n",
                "standard": "CwHypCollateral",
                "symbol": "TIA.n"
            },
            {
                "addressOrDenom": "0xD56734d7f9979dD94FAE3d67C7e928234e71cD4C",
                "chainName": "arbitrum",
                "connections": [
                    {
                        "token": "cosmos|neutron|neutron1jyyjd3x0jhgswgm6nnctxvzla8ypx50tew3ayxxwkrjfxhvje6kqzvzudq"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.n",
                "standard": "EvmHypSynthetic",
                "symbol": "TIA.n"
            },
            {
                "addressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                "chainName": "neutron",
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.n",
                "standard": "CosmosIbc",
                "symbol": "TIA.n"
            }
        ]
    },
    "TIA/eclipsemainnet-stride": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                    "amount": 120000,
                    "destination": "eclipsemainnet",
                    "origin": "stride"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "stride1pvtesu3ve7qn7ctll2x495mrqf2ysp6fws68grvcu6f7n2ajghgsh2jdj6",
                "chainName": "stride",
                "coinGeckoId": "celestia",
                "collateralAddressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|BpXHAiktwjx7fN6M9ST9wr6qKAsH27wZFhdHEhReJsR6"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "Celestia",
                "standard": "CwHypCollateral",
                "symbol": "TIA"
            },
            {
                "addressOrDenom": "BpXHAiktwjx7fN6M9ST9wr6qKAsH27wZFhdHEhReJsR6",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "9RryNMhAVJpAwAGjCAMKbbTFwgjapqPkzpGMfTQhEjf8",
                "connections": [
                    {
                        "token": "cosmos|stride|stride1pvtesu3ve7qn7ctll2x495mrqf2ysp6fws68grvcu6f7n2ajghgsh2jdj6"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "Celestia",
                "standard": "SealevelHypSynthetic",
                "symbol": "TIA"
            },
            {
                "addressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                "chainName": "stride",
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "Celestia",
                "standard": "CosmosIbc",
                "symbol": "TIA"
            }
        ]
    },
    "TIA/celestia-forma-stride": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                    "amount": 20000,
                    "destination": "forma",
                    "origin": "stride"
                },
                {
                    "addressOrDenom": "utia",
                    "amount": 20000,
                    "destination": "forma",
                    "origin": "celestia"
                },
                {
                    "addressOrDenom": "0x832d26B6904BA7539248Db4D58614251FD63dC05",
                    "amount": 20000000000000000,
                    "destination": "stride",
                    "origin": "forma"
                },
                {
                    "addressOrDenom": "0x832d26B6904BA7539248Db4D58614251FD63dC05",
                    "amount": 20000000000000000,
                    "destination": "celestia",
                    "origin": "forma"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "utia",
                "chainName": "celestia",
                "connections": [
                    {
                        "intermediateChainName": "stride",
                        "intermediateIbcDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                        "intermediateRouterAddress": "stride1h4rhlwcmdwnnd99agxm3gp7uqkr4vcjd73m4586hcuklh3vdtldqgqmjxc",
                        "sourceChannel": "channel-4",
                        "sourcePort": "transfer",
                        "token": "ethereum|forma|0x832d26B6904BA7539248Db4D58614251FD63dC05",
                        "type": "ibc-hyperlane"
                    },
                    {
                        "sourceChannel": "channel-4",
                        "sourcePort": "transfer",
                        "token": "cosmos|stride|ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                        "type": "ibc"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA",
                "standard": "CosmosIbc",
                "symbol": "TIA"
            },
            {
                "addressOrDenom": "stride1h4rhlwcmdwnnd99agxm3gp7uqkr4vcjd73m4586hcuklh3vdtldqgqmjxc",
                "chainName": "stride",
                "collateralAddressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                "connections": [
                    {
                        "token": "ethereum|forma|0x832d26B6904BA7539248Db4D58614251FD63dC05"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA",
                "standard": "CwHypCollateral",
                "symbol": "TIA"
            },
            {
                "addressOrDenom": "0x832d26B6904BA7539248Db4D58614251FD63dC05",
                "chainName": "forma",
                "connections": [
                    {
                        "token": "cosmos|stride|stride1h4rhlwcmdwnnd99agxm3gp7uqkr4vcjd73m4586hcuklh3vdtldqgqmjxc"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA",
                "standard": "EvmNative",
                "symbol": "TIA"
            },
            {
                "addressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                "chainName": "stride",
                "connections": [
                    {
                        "sourceChannel": "channel-4",
                        "sourcePort": "transfer",
                        "token": "cosmos|celestia|utia",
                        "type": "ibc"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA",
                "standard": "CosmosIbc",
                "symbol": "TIA"
            }
        ]
    },
    "TIA.n/mantapacific-neutron": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                    "amount": 270000,
                    "destination": "mantapacific",
                    "origin": "neutron"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "neutron1ch7x3xgpnj62weyes8vfada35zff6z59kt2psqhnx9gjnt2ttqdqtva3pa",
                "chainName": "neutron",
                "coinGeckoId": "celestia",
                "collateralAddressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                "connections": [
                    {
                        "token": "ethereum|mantapacific|0x6Fae4D9935E2fcb11fC79a64e917fb2BF14DaFaa"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.n",
                "standard": "CwHypCollateral",
                "symbol": "TIA.n"
            },
            {
                "addressOrDenom": "0x6Fae4D9935E2fcb11fC79a64e917fb2BF14DaFaa",
                "chainName": "mantapacific",
                "connections": [
                    {
                        "token": "cosmos|neutron|neutron1ch7x3xgpnj62weyes8vfada35zff6z59kt2psqhnx9gjnt2ttqdqtva3pa"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.n",
                "standard": "EvmHypSynthetic",
                "symbol": "TIA.n"
            },
            {
                "addressOrDenom": "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
                "chainName": "neutron",
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.n",
                "standard": "CosmosIbc",
                "symbol": "TIA.n"
            }
        ]
    },
    "TIA.o/mantapacific-osmosis": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
                    "amount": 840000,
                    "destination": "mantapacific",
                    "origin": "osmosis"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "osmo1h4y9xjcvs8lrx4z8ha48uq9a338w74dpl2ly3tf74fzvugp2kj4q9l0jkw",
                "chainName": "osmosis",
                "collateralAddressOrDenom": "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
                "connections": [
                    {
                        "token": "ethereum|mantapacific|0x88410F3D8135b4D23b98dC37C4652C6969a5B1a8"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.o",
                "standard": "CwHypCollateral",
                "symbol": "TIA.o"
            },
            {
                "addressOrDenom": "0x88410F3D8135b4D23b98dC37C4652C6969a5B1a8",
                "chainName": "mantapacific",
                "connections": [
                    {
                        "token": "cosmos|osmosis|osmo1h4y9xjcvs8lrx4z8ha48uq9a338w74dpl2ly3tf74fzvugp2kj4q9l0jkw"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "TIA.o",
                "standard": "EvmHypSynthetic",
                "symbol": "TIA.o"
            }
        ]
    },
    "TOBY/base-optimism": {
        "tokens": [
            {
                "addressOrDenom": "0xf2aCC7a8Cd1fAA7a178B1569e11505372ea7943B",
                "chainName": "base",
                "collateralAddressOrDenom": "0xb8d98a102b0079b69ffbc760c8d857a31653e56e",
                "connections": [
                    {
                        "token": "ethereum|optimism|0xf2aCC7a8Cd1fAA7a178B1569e11505372ea7943B"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/TOBY/logo.svg",
                "name": "Toby ToadGod",
                "standard": "EvmHypCollateral",
                "symbol": "TOBY"
            },
            {
                "addressOrDenom": "0xf2aCC7a8Cd1fAA7a178B1569e11505372ea7943B",
                "chainName": "optimism",
                "connections": [
                    {
                        "token": "ethereum|base|0xf2aCC7a8Cd1fAA7a178B1569e11505372ea7943B"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/TOBY/logo.svg",
                "name": "Toby ToadGod",
                "standard": "EvmHypSynthetic",
                "symbol": "TOBY"
            }
        ]
    },
    "USDC/arbitrum-bsc-kalychain-polygon": {
        "tokens": [
            {
                "addressOrDenom": "0xD0a1d1b8E10625eE7Ed4Be4Aa7afA7f169411FBd",
                "chainName": "arbitrum",
                "collateralAddressOrDenom": "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
                "connections": [
                    {
                        "token": "ethereum|bsc|0x3d7d707Df6390adB61e0Ec3eA91A8FC20E519dd0"
                    },
                    {
                        "token": "ethereum|kalychain|0x9cAb0c396cF0F4325913f2269a0b72BD4d46E3A9"
                    },
                    {
                        "token": "ethereum|polygon|0xB3dF48224FA257D55e01342592f9A24cefc2628e"
                    }
                ],
                "decimals": 6,
                "name": "USD Coin",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0x3d7d707Df6390adB61e0Ec3eA91A8FC20E519dd0",
                "chainName": "bsc",
                "collateralAddressOrDenom": "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xD0a1d1b8E10625eE7Ed4Be4Aa7afA7f169411FBd"
                    },
                    {
                        "token": "ethereum|kalychain|0x9cAb0c396cF0F4325913f2269a0b72BD4d46E3A9"
                    },
                    {
                        "token": "ethereum|polygon|0xB3dF48224FA257D55e01342592f9A24cefc2628e"
                    }
                ],
                "decimals": 6,
                "name": "USD Coin",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0x9cAb0c396cF0F4325913f2269a0b72BD4d46E3A9",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xD0a1d1b8E10625eE7Ed4Be4Aa7afA7f169411FBd"
                    },
                    {
                        "token": "ethereum|bsc|0x3d7d707Df6390adB61e0Ec3eA91A8FC20E519dd0"
                    },
                    {
                        "token": "ethereum|polygon|0xB3dF48224FA257D55e01342592f9A24cefc2628e"
                    }
                ],
                "decimals": 6,
                "name": "USD Coin",
                "standard": "EvmHypSynthetic",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0xB3dF48224FA257D55e01342592f9A24cefc2628e",
                "chainName": "polygon",
                "collateralAddressOrDenom": "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xD0a1d1b8E10625eE7Ed4Be4Aa7afA7f169411FBd"
                    },
                    {
                        "token": "ethereum|bsc|0x3d7d707Df6390adB61e0Ec3eA91A8FC20E519dd0"
                    },
                    {
                        "token": "ethereum|kalychain|0x9cAb0c396cF0F4325913f2269a0b72BD4d46E3A9"
                    }
                ],
                "decimals": 6,
                "name": "USD Coin",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            }
        ]
    },
    "USDC/arbitrum-cheesechain": {
        "tokens": [
            {
                "addressOrDenom": "0x7D824CCa0FCF6907Fb27f6134431B0649FB7db41",
                "chainName": "cheesechain",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xC9e048011E4A47584CE5b91AbD8695338A640648"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "EvmHypSynthetic",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0xC9e048011E4A47584CE5b91AbD8695338A640648",
                "chainName": "arbitrum",
                "coinGeckoId": "usd-coin",
                "collateralAddressOrDenom": "0xa8E5800AEf846A38a5814A28bcB851Ed626a0053",
                "connections": [
                    {
                        "token": "ethereum|cheesechain|0x7D824CCa0FCF6907Fb27f6134431B0649FB7db41"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "EvmHypOwnerCollateral",
                "symbol": "USDC"
            }
        ]
    },
    "USDC/base-optimism": {
        "tokens": [
            {
                "addressOrDenom": "0x524410b1e64f689eeBa15E7E511110438811B3dC",
                "chainName": "base",
                "collateralAddressOrDenom": "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
                "connections": [
                    {
                        "token": "ethereum|optimism|0x2DBe8c163f080b244D420be781abD37c1bfc51A6"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USD Coin",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0x2DBe8c163f080b244D420be781abD37c1bfc51A6",
                "chainName": "optimism",
                "connections": [
                    {
                        "token": "ethereum|base|0x524410b1e64f689eeBa15E7E511110438811B3dC"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USD Coin",
                "standard": "EvmHypSynthetic",
                "symbol": "USDC"
            }
        ]
    },
    "USDC/ancient8-ethereum": {
        "tokens": [
            {
                "addressOrDenom": "0x8b4192B9Ad1fCa440A5808641261e5289e6de95D",
                "chainName": "ethereum",
                "coinGeckoId": "usd-coin",
                "collateralAddressOrDenom": "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
                "connections": [
                    {
                        "token": "ethereum|ancient8|0x97423A68BAe94b5De52d767a17aBCc54c157c0E5"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USD Coin",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0x97423A68BAe94b5De52d767a17aBCc54c157c0E5",
                "chainName": "ancient8",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x8b4192B9Ad1fCa440A5808641261e5289e6de95D"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USD Coin",
                "standard": "EvmHypSynthetic",
                "symbol": "USDC"
            }
        ]
    },
    "USDC/eclipsemainnet-ethereum-solanamainnet": {
        "tokens": [
            {
                "addressOrDenom": "0xe1De9910fe71cC216490AC7FCF019e13a34481D7",
                "chainName": "ethereum",
                "coinGeckoId": "usd-coin",
                "collateralAddressOrDenom": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|EqRSt9aUDMKYKhzd1DGMderr3KNp29VZH3x5P7LFTC8m"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USD Coin",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "EqRSt9aUDMKYKhzd1DGMderr3KNp29VZH3x5P7LFTC8m",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "AKEWE7Bgh87GPp171b4cJPSSZfmZwQ3KaqYqXoKLNAEE",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xe1De9910fe71cC216490AC7FCF019e13a34481D7"
                    },
                    {
                        "token": "sealevel|solanamainnet|3EpVCPUgyjq2MfGeCttyey6bs5zya5wjYZ2BE6yDg6bm"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "SealevelHypSynthetic",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "3EpVCPUgyjq2MfGeCttyey6bs5zya5wjYZ2BE6yDg6bm",
                "chainName": "solanamainnet",
                "coinGeckoId": "usd-coin",
                "collateralAddressOrDenom": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|EqRSt9aUDMKYKhzd1DGMderr3KNp29VZH3x5P7LFTC8m"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "SealevelHypCollateral",
                "symbol": "USDC"
            }
        ]
    },
    "USDC/ethereum-inevm": {
        "tokens": [
            {
                "addressOrDenom": "0xED56728fb977b0bBdacf65bCdD5e17Bb7e84504f",
                "chainName": "ethereum",
                "coinGeckoId": "usd-coin",
                "collateralAddressOrDenom": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                "connections": [
                    {
                        "token": "ethereum|inevm|0x8358d8291e3bedb04804975eea0fe9fe0fafb147"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0x8358d8291e3bedb04804975eea0fe9fe0fafb147",
                "chainName": "inevm",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xED56728fb977b0bBdacf65bCdD5e17Bb7e84504f"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "EvmHypSynthetic",
                "symbol": "USDC"
            }
        ]
    },
    "USDC/ethereum-viction": {
        "tokens": [
            {
                "addressOrDenom": "0x31Dca7762930f56D81292f85E65c9D67575804fE",
                "chainName": "ethereum",
                "coinGeckoId": "usd-coin",
                "collateralAddressOrDenom": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                "connections": [
                    {
                        "token": "ethereum|viction|0xbda330ea8f3005c421c8088e638fbb64fa71b9e0"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "EvmHypCollateral",
                "symbol": "USDC"
            },
            {
                "addressOrDenom": "0xbda330ea8f3005c421c8088e638fbb64fa71b9e0",
                "chainName": "viction",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x31Dca7762930f56D81292f85E65c9D67575804fE"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDC/logo.svg",
                "name": "USDC",
                "standard": "EvmHypSynthetic",
                "symbol": "USDC"
            }
        ]
    },
    "USDT/arbitrum-bsc-kalychain-polygon": {
        "tokens": [
            {
                "addressOrDenom": "0xFDb3307a16442ed5A7C040AE1600a3B3D3C8e7D9",
                "chainName": "arbitrum",
                "collateralAddressOrDenom": "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
                "connections": [
                    {
                        "token": "ethereum|bsc|0xf4f62eC5C9d4e5464A9D1Dd738e3f50b1d652101"
                    },
                    {
                        "token": "ethereum|kalychain|0x2CA775C77B922A51FcF3097F52bFFdbc0250D99A"
                    },
                    {
                        "token": "ethereum|polygon|0x2f7c83FC82A0e39A997c262e5BAB13176C275104"
                    }
                ],
                "decimals": 6,
                "name": "Tether USD",
                "standard": "EvmHypCollateral",
                "symbol": "USDT"
            },
            {
                "addressOrDenom": "0xf4f62eC5C9d4e5464A9D1Dd738e3f50b1d652101",
                "chainName": "bsc",
                "collateralAddressOrDenom": "0x55d398326f99059fF775485246999027B3197955",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xFDb3307a16442ed5A7C040AE1600a3B3D3C8e7D9"
                    },
                    {
                        "token": "ethereum|kalychain|0x2CA775C77B922A51FcF3097F52bFFdbc0250D99A"
                    },
                    {
                        "token": "ethereum|polygon|0x2f7c83FC82A0e39A997c262e5BAB13176C275104"
                    }
                ],
                "decimals": 6,
                "name": "Tether USD",
                "standard": "EvmHypCollateral",
                "symbol": "USDT"
            },
            {
                "addressOrDenom": "0x2CA775C77B922A51FcF3097F52bFFdbc0250D99A",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xFDb3307a16442ed5A7C040AE1600a3B3D3C8e7D9"
                    },
                    {
                        "token": "ethereum|bsc|0xf4f62eC5C9d4e5464A9D1Dd738e3f50b1d652101"
                    },
                    {
                        "token": "ethereum|polygon|0x2f7c83FC82A0e39A997c262e5BAB13176C275104"
                    }
                ],
                "decimals": 6,
                "name": "Tether USD",
                "standard": "EvmHypSynthetic",
                "symbol": "USDT"
            },
            {
                "addressOrDenom": "0x2f7c83FC82A0e39A997c262e5BAB13176C275104",
                "chainName": "polygon",
                "collateralAddressOrDenom": "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0xFDb3307a16442ed5A7C040AE1600a3B3D3C8e7D9"
                    },
                    {
                        "token": "ethereum|bsc|0xf4f62eC5C9d4e5464A9D1Dd738e3f50b1d652101"
                    },
                    {
                        "token": "ethereum|kalychain|0x2CA775C77B922A51FcF3097F52bFFdbc0250D99A"
                    }
                ],
                "decimals": 6,
                "name": "Tether USD",
                "standard": "EvmHypCollateral",
                "symbol": "USDT"
            }
        ]
    },
    "USDT/eclipsemainnet-ethereum-solanamainnet": {
        "tokens": [
            {
                "addressOrDenom": "0x647C621CEb36853Ef6A907E397Adf18568E70543",
                "chainName": "ethereum",
                "coinGeckoId": "tether",
                "collateralAddressOrDenom": "0xdac17f958d2ee523a2206206994597c13d831ec7",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|5g5ujyYUNvdydwyDVCpZwPpgYRqH5RYJRi156cxyE3me"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDT/logo.svg",
                "name": "Tether USD",
                "standard": "EvmHypCollateral",
                "symbol": "USDT"
            },
            {
                "addressOrDenom": "5g5ujyYUNvdydwyDVCpZwPpgYRqH5RYJRi156cxyE3me",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "CEBP3CqAbW4zdZA57H2wfaSG1QNdzQ72GiQEbQXyW9Tm",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x647C621CEb36853Ef6A907E397Adf18568E70543"
                    },
                    {
                        "token": "sealevel|solanamainnet|Bk79wMjvpPCh5iQcCEjPWFcG1V2TfgdwaBsWBEYFYSNU"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDT/logo.svg",
                "name": "USDT",
                "standard": "SealevelHypSynthetic",
                "symbol": "USDT"
            },
            {
                "addressOrDenom": "Bk79wMjvpPCh5iQcCEjPWFcG1V2TfgdwaBsWBEYFYSNU",
                "chainName": "solanamainnet",
                "coinGeckoId": "tether",
                "collateralAddressOrDenom": "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|5g5ujyYUNvdydwyDVCpZwPpgYRqH5RYJRi156cxyE3me"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDT/logo.svg",
                "name": "USDT",
                "standard": "SealevelHypCollateral",
                "symbol": "USDT"
            }
        ]
    },
    "USDT/ethereum-inevm": {
        "tokens": [
            {
                "addressOrDenom": "0xab852e67bf03E74C89aF67C4BA97dd1088D3dA19",
                "chainName": "ethereum",
                "coinGeckoId": "tether",
                "collateralAddressOrDenom": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
                "connections": [
                    {
                        "token": "ethereum|inevm|0x97423a68bae94b5de52d767a17abcc54c157c0e5"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDT/logo.svg",
                "name": "USDT",
                "standard": "EvmHypCollateral",
                "symbol": "USDT"
            },
            {
                "addressOrDenom": "0x97423a68bae94b5de52d767a17abcc54c157c0e5",
                "chainName": "inevm",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xab852e67bf03E74C89aF67C4BA97dd1088D3dA19"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDT/logo.svg",
                "name": "USDT",
                "standard": "EvmHypSynthetic",
                "symbol": "USDT"
            }
        ]
    },
    "USDT/ethereum-viction": {
        "tokens": [
            {
                "addressOrDenom": "0x4221a16A01F61c2b38A03C52d828a7041f6AAA49",
                "chainName": "ethereum",
                "coinGeckoId": "tether",
                "collateralAddressOrDenom": "0xdAC17F958D2ee523a2206206994597C13D831ec7",
                "connections": [
                    {
                        "token": "ethereum|viction|0x48083c69f5a42c6b69abbad48ae195bd36770ee2"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDT/logo.svg",
                "name": "USDT",
                "standard": "EvmHypCollateral",
                "symbol": "USDT"
            },
            {
                "addressOrDenom": "0x48083c69f5a42c6b69abbad48ae195bd36770ee2",
                "chainName": "viction",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x4221a16A01F61c2b38A03C52d828a7041f6AAA49"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/USDT/logo.svg",
                "name": "USDT",
                "standard": "EvmHypSynthetic",
                "symbol": "USDT"
            }
        ]
    },
    "WBTC/arbitrum-bsc-kalychain-polygon": {
        "tokens": [
            {
                "addressOrDenom": "0x3CDbaBE5Bf4E6cfE10A2A326E0ad31b2d16398D4",
                "chainName": "arbitrum",
                "collateralAddressOrDenom": "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
                "connections": [
                    {
                        "token": "ethereum|bsc|0xD42Af909d323D88e0E933B6c50D3e91c279004ca"
                    },
                    {
                        "token": "ethereum|kalychain|0xaA77D4a26d432B82DB07F8a47B7f7F623fd92455"
                    },
                    {
                        "token": "ethereum|polygon|0xfF00e814A0dCB9a614585c212C78Fdc596d02e47"
                    }
                ],
                "decimals": 8,
                "name": "Wrapped BTC",
                "standard": "EvmHypCollateral",
                "symbol": "WBTC"
            },
            {
                "addressOrDenom": "0xD42Af909d323D88e0E933B6c50D3e91c279004ca",
                "chainName": "bsc",
                "collateralAddressOrDenom": "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x3CDbaBE5Bf4E6cfE10A2A326E0ad31b2d16398D4"
                    },
                    {
                        "token": "ethereum|kalychain|0xaA77D4a26d432B82DB07F8a47B7f7F623fd92455"
                    },
                    {
                        "token": "ethereum|polygon|0xfF00e814A0dCB9a614585c212C78Fdc596d02e47"
                    }
                ],
                "decimals": 8,
                "name": "Wrapped BTC",
                "standard": "EvmHypCollateral",
                "symbol": "WBTC"
            },
            {
                "addressOrDenom": "0xaA77D4a26d432B82DB07F8a47B7f7F623fd92455",
                "chainName": "kalychain",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x3CDbaBE5Bf4E6cfE10A2A326E0ad31b2d16398D4"
                    },
                    {
                        "token": "ethereum|bsc|0xD42Af909d323D88e0E933B6c50D3e91c279004ca"
                    },
                    {
                        "token": "ethereum|polygon|0xfF00e814A0dCB9a614585c212C78Fdc596d02e47"
                    }
                ],
                "decimals": 8,
                "name": "Wrapped BTC",
                "standard": "EvmHypSynthetic",
                "symbol": "WBTC"
            },
            {
                "addressOrDenom": "0xfF00e814A0dCB9a614585c212C78Fdc596d02e47",
                "chainName": "polygon",
                "collateralAddressOrDenom": "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
                "connections": [
                    {
                        "token": "ethereum|arbitrum|0x3CDbaBE5Bf4E6cfE10A2A326E0ad31b2d16398D4"
                    },
                    {
                        "token": "ethereum|bsc|0xD42Af909d323D88e0E933B6c50D3e91c279004ca"
                    },
                    {
                        "token": "ethereum|kalychain|0xaA77D4a26d432B82DB07F8a47B7f7F623fd92455"
                    }
                ],
                "decimals": 8,
                "name": "Wrapped BTC",
                "standard": "EvmHypCollateral",
                "symbol": "WBTC"
            }
        ]
    },
    "WBTC/eclipsemainnet-ethereum": {
        "tokens": [
            {
                "addressOrDenom": "0x5B4e223DE74ef8c3218e66EEcC541003CAB3121A",
                "chainName": "ethereum",
                "coinGeckoId": "wrapped-bitcoin",
                "collateralAddressOrDenom": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|A7EGCDYFw5R7Jfm6cYtKvY8dmkrYMgwRCJFkyQwpHTYu"
                    }
                ],
                "decimals": 8,
                "logoURI": "/deployments/warp_routes/WBTC/logo.svg",
                "name": "Wrapped BTC",
                "standard": "EvmHypCollateral",
                "symbol": "WBTC"
            },
            {
                "addressOrDenom": "A7EGCDYFw5R7Jfm6cYtKvY8dmkrYMgwRCJFkyQwpHTYu",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "7UTjr1VC6Z9DPsWD6mh5wPzNtufN17VnzpKS3ASpfAji",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x5B4e223DE74ef8c3218e66EEcC541003CAB3121A"
                    }
                ],
                "decimals": 8,
                "logoURI": "/deployments/warp_routes/WBTC/logo.svg",
                "name": "WBTC",
                "standard": "SealevelHypSynthetic",
                "symbol": "WBTC"
            }
        ]
    },
    "WIF/eclipsemainnet-solanamainnet": {
        "tokens": [
            {
                "addressOrDenom": "6tBGmKNxirxBYnm9khkaTtcr2fhJ9YviCgRm1RWM8NJv",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "841P4tebEgNux2jaWSjCoi9LhrVr9eHGjLc758Va3RPH",
                "connections": [
                    {
                        "token": "sealevel|solanamainnet|CuQmsT4eSF4dYiiGUGYYQxJ7c58pUAD5ADE3BbFGzQKx"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/WIF/logo.jpg",
                "name": "dogwifhat",
                "standard": "SealevelHypSynthetic",
                "symbol": "WIF"
            },
            {
                "addressOrDenom": "CuQmsT4eSF4dYiiGUGYYQxJ7c58pUAD5ADE3BbFGzQKx",
                "chainName": "solanamainnet",
                "coinGeckoId": "dogwifcoin",
                "collateralAddressOrDenom": "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|6tBGmKNxirxBYnm9khkaTtcr2fhJ9YviCgRm1RWM8NJv"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/WIF/logo.jpg",
                "name": "dogwifhat",
                "standard": "SealevelHypCollateral",
                "symbol": "WIF"
            }
        ]
    },
    "milkTIA.o/mantapacific-osmosis": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA",
                    "amount": 840000,
                    "destination": "mantapacific",
                    "origin": "osmosis"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "osmo17xuecsykqw2xcxwv8cau7uy4hgdwqt0u4qxflyc2yshhggpazfjs6kfqd3",
                "chainName": "osmosis",
                "collateralAddressOrDenom": "factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA",
                "connections": [
                    {
                        "token": "ethereum|mantapacific|0x32474653127048d9fC20000e21dEd396b47968E8"
                    }
                ],
                "decimals": 6,
                "name": "milkTIA.o",
                "standard": "CwHypCollateral",
                "symbol": "milkTIA.o"
            },
            {
                "addressOrDenom": "0x32474653127048d9fC20000e21dEd396b47968E8",
                "chainName": "mantapacific",
                "connections": [
                    {
                        "token": "cosmos|osmosis|osmo17xuecsykqw2xcxwv8cau7uy4hgdwqt0u4qxflyc2yshhggpazfjs6kfqd3"
                    }
                ],
                "decimals": 6,
                "name": "milkTIA.o",
                "standard": "EvmHypSynthetic",
                "symbol": "milkTIA.o"
            }
        ]
    },
    "stTIA/eclipsemainnet-stride": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                    "amount": 120000,
                    "destination": "eclipsemainnet",
                    "origin": "stride"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "stride134axwdlam929m3mar3wv95nvkyep7mr87ravkqcpf8dfe3v0pjlqwrw6ee",
                "chainName": "stride",
                "coinGeckoId": "stride-staked-tia",
                "collateralAddressOrDenom": "stutia",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|tKUHyJ5NxhnwU94JUmzh1ekukDcHHX8mZF6fqxbMwX6"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/stTIA/logo.svg",
                "name": "Stride Staked TIA",
                "standard": "CwHypCollateral",
                "symbol": "stTIA"
            },
            {
                "addressOrDenom": "tKUHyJ5NxhnwU94JUmzh1ekukDcHHX8mZF6fqxbMwX6",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "V5m1Cc9VK61mKL8xVYrjR7bjD2BC5VpADLa6ws3G8KM",
                "connections": [
                    {
                        "token": "cosmos|stride|stride134axwdlam929m3mar3wv95nvkyep7mr87ravkqcpf8dfe3v0pjlqwrw6ee"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/stTIA/logo.svg",
                "name": "Stride Staked TIA",
                "standard": "SealevelHypSynthetic",
                "symbol": "stTIA"
            },
            {
                "addressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                "chainName": "stride",
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/TIA/logo.svg",
                "name": "Celestia",
                "standard": "CosmosIbc",
                "symbol": "TIA"
            }
        ]
    },
    "stTIA/ethereum-stride": {
        "options": {
            "interchainFeeConstants": [
                {
                    "addressOrDenom": "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
                    "amount": 1050000,
                    "destination": "ethereum",
                    "origin": "stride"
                }
            ]
        },
        "tokens": [
            {
                "addressOrDenom": "stride1z3lz9n0549v95q6yllghezugdra6ezm68jtf4ve5hsz8k867k9cq3pc2f8",
                "chainName": "stride",
                "collateralAddressOrDenom": "stutia",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0x48A612A6da945205a221E94BB9F40B0550Cd2C4e"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/stTIA/logo.svg",
                "name": "stTIA",
                "standard": "CwHypCollateral",
                "symbol": "stTIA"
            },
            {
                "addressOrDenom": "0x48A612A6da945205a221E94BB9F40B0550Cd2C4e",
                "chainName": "ethereum",
                "connections": [
                    {
                        "token": "cosmos|stride|stride1z3lz9n0549v95q6yllghezugdra6ezm68jtf4ve5hsz8k867k9cq3pc2f8"
                    }
                ],
                "decimals": 6,
                "logoURI": "/deployments/warp_routes/stTIA/logo.svg",
                "name": "stTIA",
                "standard": "EvmHypSynthetic",
                "symbol": "stTIA"
            }
        ]
    },
    "tETH/eclipsemainnet-ethereum": {
        "tokens": [
            {
                "addressOrDenom": "0xc2495f3183F043627CAECD56dAaa726e3B2D9c09",
                "chainName": "ethereum",
                "coinGeckoId": "ethereum",
                "collateralAddressOrDenom": "0x19e099B7aEd41FA52718D780dDA74678113C0b32",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|6GM7hy6M6LjhadG1xuKXPQ3jPC1eieEszR8DforoRzUp"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/tETH/logo.svg",
                "name": "Eclipse Turbo ETH",
                "standard": "EvmHypCollateral",
                "symbol": "tETH"
            },
            {
                "addressOrDenom": "6GM7hy6M6LjhadG1xuKXPQ3jPC1eieEszR8DforoRzUp",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "GU7NS9xCwgNPiAdJ69iusFrRfawjDDPjeMBovhV1d4kn",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xc2495f3183F043627CAECD56dAaa726e3B2D9c09"
                    }
                ],
                "decimals": 9,
                "foreignDecimals": 18,
                "logoURI": "/deployments/warp_routes/tETH/logo.svg",
                "name": "tETH",
                "standard": "SealevelHypSynthetic",
                "symbol": "tETH"
            }
        ]
    },
    "weETHs/eclipsemainnet-ethereum": {
        "tokens": [
            {
                "addressOrDenom": "0xef899e92DA472E014bE795Ecce948308958E25A2",
                "chainName": "ethereum",
                "coinGeckoId": "etherfi-weeths",
                "collateralAddressOrDenom": "0x917cee801a67f933f2e6b33fc0cd1ed2d5909d88",
                "connections": [
                    {
                        "token": "sealevel|eclipsemainnet|7Zx4wU1QAw98MfvnPFqRh1oyumek7G5VAX6TKB3U1tcn"
                    }
                ],
                "decimals": 18,
                "logoURI": "/deployments/warp_routes/weETHs/logo.svg",
                "name": "Super Symbiotic LRT",
                "standard": "EvmHypCollateral",
                "symbol": "weETHs"
            },
            {
                "addressOrDenom": "7Zx4wU1QAw98MfvnPFqRh1oyumek7G5VAX6TKB3U1tcn",
                "chainName": "eclipsemainnet",
                "collateralAddressOrDenom": "F72PqK74jc28zjC7kWDk6ykJ2ZAbjNzn2jaAY9v9M6om",
                "connections": [
                    {
                        "token": "ethereum|ethereum|0xef899e92DA472E014bE795Ecce948308958E25A2"
                    }
                ],
                "decimals": 9,
                "logoURI": "/deployments/warp_routes/weETHs/logo.svg",
                "name": "Super Symbiotic LRT",
                "standard": "SealevelHypSynthetic",
                "symbol": "weETHs"
            }
        ]
    }
};
